import React from 'react';
import { PRODUCT_STATES, DISCOUNT_CATEGORY_EMPTY } from './constants';
import AutocompleteSelect from '../../shared/AutocompleteSelect';
import ProductRangeFilter from './ProductRangeFilter';
import '../../../styles/admin-product-filters.css';

const ProductFilters = ({
  stateFilter,
  setStateFilter,
  showStateDropdown,
  setShowStateDropdown,
  stateDropdownRef,
  categoryIdsFilter,
  setCategoryIdsFilter,
  discountCategoryNamesFilter,
  setDiscountCategoryNamesFilter,
  showDiscountCategoryDropdown,
  setShowDiscountCategoryDropdown,
  discountCategoryDropdownRef,
  discountCategories,
  quantityFromFilter,
  setQuantityFromFilter,
  quantityToFilter,
  setQuantityToFilter,
  priceFromFilter,
  setPriceFromFilter,
  priceToFilter,
  setPriceToFilter,
  discountFromFilter,
  setDiscountFromFilter,
  discountToFilter,
  setDiscountToFilter,
  productIdFilter,
  setProductIdFilter,
  searchFilter,
  setSearchFilter,
  categories,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  hasActiveFilters,
  getStateFilterLabel,
  getCategoryFilterLabel,
  getDiscountCategoryFilterLabel,
  handleSearch,
  handleResetFilters,
  onAddProduct,
  onOpenBulkCreate,
  productModalId = '#productModal',
  onOpenCurrencyRates,
}) => {
  return (
    <section className='ap-product-filters' aria-label='Фільтри товарів'>
      {/* Filters - Row 1: Статус, Категорія, Кількість від/до, Ціна від/до */}
      <div className='row filters mb-3 ap-filter-row'>
        <div className='ap-filter-choice py-1 px-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            Статус:
          </p>
          <div className='position-relative status-dropdown-container' ref={stateDropdownRef}>
            <button
              type='button'
              className='form-control text-left d-flex justify-content-between align-items-center'
              onClick={e => {
                e.stopPropagation();
                setShowStateDropdown(!showStateDropdown);
              }}
              style={{ fontSize: '0.875rem', backgroundColor: 'white', cursor: 'pointer' }}
            >
              <span>
                {stateFilter.length === 0
                  ? 'Всі'
                  : stateFilter.length === 1
                  ? getStateFilterLabel(stateFilter[0])
                  : `Обрано: ${stateFilter.length}`}
              </span>
              <i className={`bi bi-chevron-${showStateDropdown ? 'up' : 'down'}`}></i>
            </button>
            {showStateDropdown && (
              <div
                className='position-absolute w-100 border rounded bg-white shadow-sm'
                style={{ zIndex: 1000, marginTop: '2px', maxHeight: '200px', overflowY: 'auto' }}
                onClick={e => e.stopPropagation()}
              >
                <div className='p-2'>
                  {PRODUCT_STATES.filter(s => s.value !== '').map(s => (
                    <div key={s.value} className='form-check d-flex align-items-center'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={`state-${s.value}`}
                        checked={stateFilter.includes(s.value)}
                        onChange={e => {
                          if (e.target.checked) {
                            setStateFilter([...stateFilter, s.value]);
                          } else {
                            setStateFilter(stateFilter.filter(v => v !== s.value));
                          }
                        }}
                        style={{
                          width: '18px',
                          height: '18px',
                          marginTop: '0',
                          cursor: 'pointer',
                          flexShrink: 0,
                        }}
                      />
                      <label
                        className='form-check-label ml-2'
                        htmlFor={`state-${s.value}`}
                        style={{
                          fontSize: '0.875rem',
                          cursor: 'pointer',
                          marginBottom: '0',
                          flex: 1,
                        }}
                      >
                        {s.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='ap-filter-choice py-1 px-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            Категорія:
          </p>
          <AutocompleteSelect
            label='Категорія'
            className='ap-category-autocomplete'
            placeholder='Всі'
            searchPlaceholder='Знайти категорію'
            overlay
            summary
            options={categories.map(category => ({ value: category.id, label: category.name }))}
            value={categoryIdsFilter}
            onChange={setCategoryIdsFilter}
            missingLabel={id => `Категорія #${id}`}
          />
        </div>
        <div className='ap-filter-choice py-1 px-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            Категорія знижки:
          </p>
          <div className='position-relative' ref={discountCategoryDropdownRef}>
            <button
              type='button'
              className='form-control text-left d-flex justify-content-between align-items-center'
              onClick={e => {
                e.stopPropagation();
                setShowDiscountCategoryDropdown(!showDiscountCategoryDropdown);
              }}
              style={{ fontSize: '0.875rem', backgroundColor: 'white', cursor: 'pointer' }}
            >
              <span>
                {!discountCategoryNamesFilter || discountCategoryNamesFilter.length === 0
                  ? 'Всі'
                  : discountCategoryNamesFilter.length === 1
                  ? discountCategoryNamesFilter[0] === DISCOUNT_CATEGORY_EMPTY
                    ? 'Немає'
                    : discountCategoryNamesFilter[0]
                  : `Обрано: ${discountCategoryNamesFilter.length}`}
              </span>
              <i className={`bi bi-chevron-${showDiscountCategoryDropdown ? 'up' : 'down'}`}></i>
            </button>
            {showDiscountCategoryDropdown && (
              <div
                className='position-absolute w-100 border rounded bg-white shadow-sm'
                style={{ zIndex: 1000, marginTop: '2px', maxHeight: '200px', overflowY: 'auto' }}
                onClick={e => e.stopPropagation()}
              >
                <div className='p-2'>
                  <div className='form-check d-flex align-items-center'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='discountCat-empty'
                      checked={(discountCategoryNamesFilter || []).includes(
                        DISCOUNT_CATEGORY_EMPTY,
                      )}
                      onChange={e => {
                        if (e.target.checked) {
                          setDiscountCategoryNamesFilter([
                            ...(discountCategoryNamesFilter || []),
                            DISCOUNT_CATEGORY_EMPTY,
                          ]);
                        } else {
                          setDiscountCategoryNamesFilter(
                            (discountCategoryNamesFilter || []).filter(
                              v => v !== DISCOUNT_CATEGORY_EMPTY,
                            ),
                          );
                        }
                      }}
                      style={{
                        width: '18px',
                        height: '18px',
                        marginTop: '0',
                        cursor: 'pointer',
                        flexShrink: 0,
                      }}
                    />
                    <label
                      className='form-check-label ml-2'
                      htmlFor='discountCat-empty'
                      style={{
                        fontSize: '0.875rem',
                        cursor: 'pointer',
                        marginBottom: '0',
                        flex: 1,
                      }}
                    >
                      Немає
                    </label>
                  </div>
                  {(discountCategories || []).map(name => (
                    <div key={name} className='form-check d-flex align-items-center'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={`discountCat-${name}`}
                        checked={(discountCategoryNamesFilter || []).includes(name)}
                        onChange={e => {
                          if (e.target.checked) {
                            setDiscountCategoryNamesFilter([
                              ...(discountCategoryNamesFilter || []),
                              name,
                            ]);
                          } else {
                            setDiscountCategoryNamesFilter(
                              (discountCategoryNamesFilter || []).filter(v => v !== name),
                            );
                          }
                        }}
                        style={{
                          width: '18px',
                          height: '18px',
                          marginTop: '0',
                          cursor: 'pointer',
                          flexShrink: 0,
                        }}
                      />
                      <label
                        className='form-check-label ml-2'
                        htmlFor={`discountCat-${name}`}
                        style={{
                          fontSize: '0.875rem',
                          cursor: 'pointer',
                          marginBottom: '0',
                          flex: 1,
                        }}
                      >
                        {name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <ProductRangeFilter
          label='Залишок, шт.'
          from={quantityFromFilter}
          to={quantityToFilter}
          onFromChange={setQuantityFromFilter}
          onToChange={setQuantityToFilter}
        />
        <ProductRangeFilter
          label='Ціна, грн'
          from={priceFromFilter}
          to={priceToFilter}
          onFromChange={setPriceFromFilter}
          onToChange={setPriceToFilter}
        />
        <ProductRangeFilter
          label='Знижка, %'
          from={discountFromFilter}
          to={discountToFilter}
          onFromChange={setDiscountFromFilter}
          onToChange={setDiscountToFilter}
          max={100}
        />
        {onOpenCurrencyRates && (
          <div className='ap-currency-action py-1 px-1 d-flex align-items-end'>
            <button
              type='button'
              className='btn btn-outline-secondary p-2'
              onClick={onOpenCurrencyRates}
              title='Курси валют'
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              <i className='bi bi-currency-exchange'></i>
            </button>
          </div>
        )}
      </div>

      {/* Filters - Row 2: ID (вузька колонка), Пошук (решта місця) */}
      <div className='row filters mb-3'>
        <div className='col-1 py-1 px-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            ID:
          </p>
          <input
            type='number'
            className='form-control'
            min='1'
            placeholder='ID'
            value={productIdFilter}
            onChange={e => setProductIdFilter(e.target.value)}
            style={{ fontSize: '0.875rem' }}
          />
        </div>
        <div className='col-11 py-1 px-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            Пошук по назві товару:
          </p>
          <div className='position-relative d-flex align-items-center'>
            <input
              type='text'
              className='form-control pr-4'
              placeholder='Введіть назву або артикул товару'
              value={searchFilter}
              onChange={e => setSearchFilter(e.target.value)}
              style={{ fontSize: '0.875rem' }}
              onKeyPress={e => {
                if (e.key === 'Enter') handleSearch();
              }}
            />
            {searchFilter && (
              <button
                type='button'
                className='btn p-0 border-0 bg-transparent position-absolute'
                style={{
                  right: '8px',
                  fontSize: '1.1rem',
                  lineHeight: 1,
                  color: '#6c757d',
                  cursor: 'pointer',
                }}
                onClick={() => setSearchFilter('')}
                title='Очистити пошук'
                aria-label='Очистити пошук'
              >
                <i className='bi bi-x'></i>
              </button>
            )}
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 p-0'>
          <div
            className='mb-3 d-flex justify-content-between align-items-start flex-wrap'
            style={{ gap: '0.5rem' }}
          >
            <div
              className='d-flex flex-wrap align-items-center'
              style={{ gap: '0.5rem', flex: '1', minWidth: '0' }}
            >
              {hasActiveFilters ? (
                <>
                  <span className='font-weight-bold' style={{ fontSize: '0.875rem' }}>
                    Активні фільтри:
                  </span>
                  {productIdFilter !== '' && productIdFilter != null && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      ID: {productIdFilter}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => setProductIdFilter('')}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {stateFilter.length > 0 && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Статус: {stateFilter.map(v => getStateFilterLabel(v)).join(', ')}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => setStateFilter([])}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {(discountCategoryNamesFilter || []).length > 0 && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Категорія знижки: {getDiscountCategoryFilterLabel()}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => setDiscountCategoryNamesFilter([])}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {categoryIdsFilter.length > 0 && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Категорія: {getCategoryFilterLabel()}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => setCategoryIdsFilter([])}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {searchFilter && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Пошук: {searchFilter}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => setSearchFilter('')}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {(quantityFromFilter !== '' || quantityToFilter !== '') && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Кількість: {quantityFromFilter !== '' ? quantityFromFilter : '—'} …{' '}
                      {quantityToFilter !== '' ? quantityToFilter : '—'}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => {
                          setQuantityFromFilter('');
                          setQuantityToFilter('');
                        }}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {(priceFromFilter !== '' || priceToFilter !== '') && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Ціна: {priceFromFilter !== '' ? priceFromFilter : '—'} …{' '}
                      {priceToFilter !== '' ? priceToFilter : '—'}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => {
                          setPriceFromFilter('');
                          setPriceToFilter('');
                        }}
                        title='Скинути фільтр'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                  {(discountFromFilter !== '' || discountToFilter !== '') && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{ fontSize: '.875rem', padding: '.35rem .5rem' }}
                    >
                      Знижка: {discountFromFilter || '0'} … {discountToFilter || '100'}%
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        style={{ color: 'inherit', lineHeight: 1 }}
                        onClick={() => {
                          setDiscountFromFilter('');
                          setDiscountToFilter('');
                        }}
                        title='Скинути знижку'
                        aria-label='Скинути фільтр знижки'
                      >
                        <i className='bi bi-x' aria-hidden='true' />
                      </button>
                    </span>
                  )}
                  {(sortBy !== 'id' || sortOrder !== 'desc') && (
                    <span
                      className='badge badge-dark d-inline-flex align-items-center'
                      style={{
                        fontSize: '0.875rem',
                        padding: '0.35rem 0.5rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Сортування: {sortBy} {sortOrder === 'asc' ? '↑' : '↓'}
                      <button
                        type='button'
                        className='btn p-0 ml-2 border-0 bg-transparent'
                        onClick={() => {
                          setSortBy('id');
                          setSortOrder('desc');
                        }}
                        title='Скинути сортування'
                        style={{
                          fontSize: '0.875rem',
                          color: 'inherit',
                          lineHeight: '1',
                          padding: 0,
                          cursor: 'pointer',
                          opacity: 0.8,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.opacity = '1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.opacity = '0.8';
                        }}
                      >
                        <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                      </button>
                    </span>
                  )}
                </>
              ) : null}
            </div>
            <div className='d-flex align-items-center' style={{ flexShrink: 0 }}>
              <button
                className='btn btn-danger mr-2'
                onClick={handleResetFilters}
                style={{ fontSize: '0.875rem' }}
              >
                Очистити фільтр та сортування
              </button>
              <button
                className='btn btn-dark mr-2'
                onClick={handleSearch}
                style={{ fontSize: '0.875rem' }}
              >
                Оновити
              </button>
              <button
                className='btn btn-success mr-2'
                data-toggle='modal'
                data-target={productModalId}
                data-backdrop='static'
                data-keyboard='false'
                onClick={onAddProduct}
                style={{ fontSize: '0.875rem' }}
              >
                <i className='bi bi-plus-circle mr-1'></i>
                Додати продукт
              </button>
              <button
                type='button'
                className='btn btn-success'
                onClick={onOpenBulkCreate}
                title='Масове додавання товарів'
                aria-label='Масове додавання товарів'
                style={{ fontSize: '0.875rem', width: '2.125rem', padding: '0.375rem 0' }}
              >
                <i className='bi bi-plus-square'></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductFilters;
